import { createAction, createReducer, on, props } from "@ngrx/store";
import { LookupDto } from "../models";

/** Action requesting that lookup reference data be loaded. */
export const lookupsLoad = createAction('[Lookups] load lookups', props<{lookups: LookupState}>());
/** Action signalling that lookup reference data was loaded from the API. */
export const lookupsLoadedFromApi = createAction('[Lookups] lookups loaded from api', props<{lookups: LookupState}>());
/** Action signalling that loading lookup reference data from the API failed. */
export const lookupsLoadedFromApiFailed = createAction('[Lookups] lookups load from api failed', props<{lookups: LookupState}>());

/**
 * Shape of the `lookups` ngrx feature state: reference-data lists keyed by
 * lookup category.
 */
export interface LookupState
{
    /** Gender options. */
    gender: LookupDto[],
    /** Race demographic options. */
    race: LookupDto[],
    /** Merchant store-type categories. */
    storeType: LookupDto[],
    /** South African provinces. */
    province: LookupDto[],
    /** Next-of-kin relationship categories. */
    nextOfKinRelationship: LookupDto[],
    /** Field agents for merchant onboarding. */
    fieldAgent: LookupDto[],
    /** Mobile network operators. */
    mobileNetwork: LookupDto[],
    /** South African banks. */
    bank: LookupDto[],
    /** Users permitted to verify claims. */
    claimVerificationUsers: LookupDto[],
    /** Users permitted to approve claims. */
    claimApprovalUsers: LookupDto[],
}

const initialState: LookupState = {
    gender: [],
    race: [],
    storeType: [],
    province: [],
    nextOfKinRelationship: [],
    fieldAgent: [],
    mobileNetwork: [],
    bank: [],
    claimVerificationUsers: [],
    claimApprovalUsers: [],
}

/** Reducer for the `lookups` ngrx feature; stores API-loaded reference data. */
export const lookupReducer = createReducer(
    initialState,
    on(lookupsLoadedFromApi, (state, {lookups}) => ({ 
        gender: lookups.gender,
        race: lookups.race,
        storeType: lookups.storeType,
        province: lookups.province,
        nextOfKinRelationship: lookups.nextOfKinRelationship,
        fieldAgent: lookups.fieldAgent,  
        mobileNetwork: lookups.mobileNetwork,
        bank: lookups.bank,
        claimApprovalUsers: lookups.claimApprovalUsers,
        claimVerificationUsers: lookups.claimVerificationUsers
    }))
);